import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from "./pages/App";
import * as ReactDOM from "react-dom/client";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Events from "./pages/Events";
import Home from "./pages/Home";
import CommunityFeed from "./pages/CommunityFeed";
import NewParticipant from "./components/NewParticipant";
import Stats from "./pages/Stats";

document.body.style = 'background: rgb(248 249 250);';
const root = ReactDOM.createRoot(document.getElementById('root'))
const router = createBrowserRouter([
    {
        path: "/bike",
        element: <App/>,
        children: [
            {
                index: true,
                element: <Home/>,
            },
            {
                path: "/bike/home",
                element: <Home/>,
            },
            {
                path: "/bike/join",
                element: <NewParticipant/>,
            },
            {
                path: "/bike/events",
                element: <Events/>,
            },
            {
                path: "/bike/events/:id",
                element: <Events/>,
            },
            {
                path: "/bike/feed",
                element: <CommunityFeed/>,
            },
            {
                path: "/bike/stats",
                element: <Stats/>,
            }
        ]
    }
]);
root.render(
    <React.StrictMode>
        <RouterProvider router={router}/>
    </React.StrictMode>,
)
